<template>
<div >
	<Loader :show="loading"></Loader>
	<b-modal id="modalEmployee" :title="title" hide-footer no-close-on-backdrop no-close-on-esc @close="close">
		<EmployeeForm :id="id" @loaded="loading=false" @updated="close()" ></EmployeeForm>
	</b-modal>	
</div>
</template>

<script>
import EmployeeForm from '@/views/employees/EmployeeForm'
import Loader from '@/components/Loader'

export default {
	name: 'EmployeeModal',
	components:{
		EmployeeForm,
		Loader
	},
	data () {
		return {
			title: 'Crear funcionario',
			show: false,
			loading:false,
			id: null
		}
	},
	methods: {
		open (id=null) {
			this.id = id
			if( id!==null ){
				this.title = 'Editar funcionario'
			}else{	
				this.title = 'Crear funcionario'
			}
			this.loading = true
			this.showModal()
		},
		showModal() {
			this.show = true
			this.$bvModal.show('modalEmployee')
		},
		close () {
			this.show = false
			this.form = {}
			this.$emit('updated')
			this.$bvModal.hide('modalEmployee')
		},
	}
}


</script>
